import { CheckIcon } from '@heroicons/react/solid'
import cx from 'classnames'
import React from 'react'
import Image from 'shared/components/base/image/Image'
import OperatorExtension from 'store/slice/call-detail/types'

type Props = {
  index?: number
  operator: Partial<OperatorExtension>
  onSelect: (operator: Partial<OperatorExtension>) => void
  className?: string
  isSelected?: boolean
}

function OperatorCard({
  index,
  operator,
  className,
  onSelect,
  isSelected,
  ...rest
}: Props) {
  const handleClick = () => {
    if (!operator.isBusy) {
      onSelect(operator)
    }
  }

  return (
    <div
      onClick={handleClick}
      className={cx(
        'min-h-[5.2rem] items-center border rounded-lg flex justify-between mb-3 hover:cursor-pointer hover:shadow-custom1 relative transition-colors duration-200 ease-in-out',
        operator?.isBusy && ' opacity-60 relative bg-[#F7F7F7]',
        isSelected && 'border-1 border-orange-bullet bg-[#F37E5D4A]',
        (isSelected || operator?.isBusy) && '!cursor-default !shadow-none',
        className
      )}
      {...rest}
    >
      <div className="flex justify-center items-center">
        <div className="w-[1.625rem] h-[1.625rem] bg-[#F3F6F9] mx-5 rounded-full flex items-end justify-center">
          <span className="leading-5 text-sm font-medium">{index}</span>
        </div>

        <div className="w-11 h-11 relative">
          <Image
            className="rounded-full h-11 w-11 object-fill"
            src={operator?.imageUrl || ''}
            height={44}
            width={44}
            alt={operator?.fullName}
          />

          <div className="absolute w-3 h-3 bg-[#F3F6F9] rounded-full right-0 bottom-0">
            {operator.isBusy ? (
              <div className="w-2 h-2 bg-red-500 rounded-full absolute right-0.5 bottom-0.5" />
            ) : (
              <div className="w-2 h-2 bg-green-600 rounded-full absolute right-0.5 bottom-0.5" />
            )}
          </div>
        </div>
        <div className="mr-2">
          <p className="font-medium text-[13px]">{operator?.fullName}</p>
          <p className="font-normal text-[#5F5F5F] text-[11px]">
            {operator?.userPosition || 'نامشخص'}
          </p>
        </div>
      </div>

      <div
        className={cx(
          'h-9 w-9 rounded-full border-1 mr-2 ml-9 flex justify-center items-center',
          isSelected
            ? ' bg-orange-bullet border-white'
            : 'border-1 border-gray-extra-light'
        )}
      >
        {isSelected && <CheckIcon width="30px" height="22px" fill="#fff" />}
      </div>

      {operator?.isBusy ? (
        <p className="absolute left-0.5 bg-[#FEF0ED] bottom-0 text-[#F37E5D]  text-[9px] font-semibold rounded-1 p-[0.1rem] ">
          در حال مکالمه
        </p>
      ) : null}
    </div>
  )
}

export default OperatorCard
